import { Component, } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SafeResourceUrl } from '@angular/platform-browser';
import { AppConfigService } from 'app/services/appConfig/appConfigService';


@Component({
	selector: 'eup-patient-app',
	templateUrl: './patientApp.component.html',
	styleUrls: ['./patientApp.component.scss']
})
export class PatientAppModalComponent {
	patientAppUrl: SafeResourceUrl;
	patientAppIframeName = 'inline-patient-app';

	get isProduction(): boolean {
		return this.appConfigService.appSettings.isProduction;
	}

	constructor(
		public bsModalRef: BsModalRef,
		private appConfigService: AppConfigService
	) { }
}
